import type { ReactNode } from 'react'

import estilos from './Pagina.module.css'

export function Pagina({
  titulo,
  descricao,
  acoes,
  children,
}: {
  titulo: string
  descricao?: ReactNode
  acoes?: ReactNode
  children: ReactNode
}) {
  return (
    <div className={estilos.pagina}>
      <header className={estilos.cabecalho}>
        <div className={estilos.titulos}>
          <h1>{titulo}</h1>
          {descricao && <p className={estilos.descricao}>{descricao}</p>}
        </div>
        {acoes && <div className={estilos.acoes}>{acoes}</div>}
      </header>
      {children}
    </div>
  )
}

/**
 * A barra de filtros.
 *
 * Uma só, acima de tudo que ela recorta — nunca um filtro dentro do cartão de
 * um gráfico. Quando cada gráfico tem o seu, dois painéis lado a lado passam a
 * mostrar recortes diferentes com a mesma cara, e foi assim que o painel do R
 * acabou com três cópias divergentes.
 */
export function BarraFiltros({ children, acoes }: { children: ReactNode; acoes?: ReactNode }) {
  return (
    <section className={estilos.filtros} aria-label="Filtros">
      <div className={estilos.filtrosCampos}>{children}</div>
      {acoes && <div className={estilos.filtrosAcoes}>{acoes}</div>}
    </section>
  )
}

/** Pilha vertical com o espaçamento padrão entre cartões. */
export function Pilha({ children }: { children: ReactNode }) {
  return <div className={estilos.pilha}>{children}</div>
}
